import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "ps-0 mb-0 list-unstyled fw-medium mb-2 d-flex gap-3 flex-row flex-wrap align-items-center align-items" }
const _hoisted_2 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link) => {
      return (_openBlock(), _createElementBlock("li", {
        class: "d-inline-block",
        key: link
      }, [
        _createElementVNode("a", {
          href: _ctx.$t(`footer_links.${link}.${_ctx.env}`).trim().length === 0 ? undefined : _ctx.$t(`footer_links.${link}.${_ctx.env}`),
          class: "text-decoration-none text-body-secondary transition cursor-pointer",
          target: "_blank"
        }, _toDisplayString(_ctx.$t(`page.footer_link.${link}`)), 9 /* TEXT, PROPS */, _hoisted_2)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}